module.exports = __webpack_public_path__ + "e1.no2.5d726a12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/e1.no2.jpg
// module id = i59R
// module chunks = 0